<template>
  <div id="single-picker" class="single-picker">
    <van-popup
      v-model="show"
      :close-on-click-overlay="false"
      position="bottom"
      :style="{height:'300px' }"
    >
      <van-picker
        :columns="columns"
        :title="title"
        show-toolbar
        @change="changeClick"
        @cancel="cancelClick"
        @confirm="confirmClick"
      />
    </van-popup>
  </div>
</template>

<script>
export default {
  name: 'single-picker',
  props: {
    show: false,
    type: 0 // 1 风险评测选择社区  2 应急保障 选择小时 3 5G时代 4 选择经办人 5 专家招募(等级职称选择) 6 专家咨询问题类型
  },
  data () {
    return {
      title: '',
      columns: [],
      value: '' // 选中
    }
  },
  methods: {
    changeClick: function (picker, value, index) {
      this.value = value
    },
    confirmClick: function () {
      console.log('picker-value------======' + this.value)
      this.$emit('selectedSPicker', this.value)
    },
    cancelClick: function () {
      this.$emit('selectedSPicker', '')
    },
    loadWorkData: function () {
      var _this = this
      this.title = '工作类型'
      this.utils.GET(this.accountUrl + '/emergencyForum/getWorkTypes', function (response) {
        let data = response.data
        for (let i = 0; i < data.length; i++) {
          let item = data[i]
          item.text = item.work_type
          if (i === 0) {
            _this.value = item
          }
          _this.columns.push(item)
        }
      })
    },
    loadPersonData: function () {
      // 获取 经办人列表
      var _this = this
      this.title = '经办人'
      this.utils.GET(this.accountUrl + '/ESign/personList', function (response) {
        let data = response.data
        for (let i = 0; i < data.length; i++) {
          let item = data[i]
          item.text = item.name
          if (i === 0) {
            _this.value = item
          }
          _this.columns.push(item)
        }
      })
    },
    loadQuestionData: function () {
      var _this = this
      this.title = '问题类型'
      this.utils.GET(this.accountUrl + '/issue/getCategoryList', function (response) {
        let data = response.data
        for (let i = 0; i < data.length; i++) {
          let item = data[i]
          item.text = item.name
          if (i === 0) {
            _this.value = item
          }
          _this.columns.push(item)
        }
      })
    }
  },
  mounted () {
    if (parseInt(this.type) === 1) {
      this.columns = ['庙宇垴社区', '长乐山社区', '卫王社区', '詹爱宇社区', '詹本六社区', '官山社区', '官塘社区',
        '张家湾社区', '东方路社区', '东方山社区', '蜂烈山社区', '王寿社区', '袁家畈社区',
        '江洋社区', '老鹳庙社区', '石榴园社区', '柯尔山社区', '马鞍山社区', '皇姑岭社区',
        '箭楼下社区', '陈百臻社区', '杭州东路社区', '青龙山社区', '肖家铺社区', '大塘社区',
        '团结社区', '铜花社区', '神牛社区', '新星社区', '友谊社区', '老下陆社区',
        '西花苑社区', '铜都社区', '孔雀苑社区', '陆家铺社区', '康宁社区', '胜利社区']
      this.title = '街道'
      this.value = '庙宇垴社区'
    }
    if (parseInt(this.type) === 2) {
      this.columns = ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12',
        '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23']
      this.value = '00'
      this.title = ''
    }
    if (parseInt(this.type) === 3) {
      this.loadWorkData()
    }
    if (parseInt(this.type) === 4) {
      this.loadPersonData()
    }
    if (parseInt(this.type) === 5) {
      this.title = '等级职称'
      this.value = '总监职级'
      this.columns = ['总监职级', '副总监职级', '助理总监职级', '高级指挥长', '一级指挥长', '二级指挥长',
        '三级指挥长', '一级指挥员', '二级指挥员', '三级指挥员', '四级指挥员']
    }
    if (parseInt(this.type) === 6) {
      this.loadQuestionData()
    }
    if (parseInt(this.type) === 7) {
      this.columns = ['胡家湾社区', '石料山社区', '花园路社区', '牧羊湖社区', '八卦嘴社区', '澄月社区', '陈家湾社区', '大智路社区', '磁湖社区', '十五冶社区', '月亮山社区', '八泉社区', '和平街社区', '临江社区', '飞云社区', '叶家塘社区', '新建区社区', '黄思湾社区', '田园社区', '马家嘴社区']
      this.title = '街道'
      this.value = '胡家湾社区'
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/single-picker.vue